module.exports = __webpack_public_path__ + "static/media/item-header-shaq.b20babea.png";